<template>
  <div class="RehabList section col_w_3 rehab_list_section">
    <div class="section_wrap row" style="min-height: 615px; overflow: auto">
      <h6 class="--blue70 mb20 section_title">
        {{ $t('rehabilitation.list') }}
      </h6>
      <h6
          v-show="orderByData.columnKey !== undefined"
          class="--blue70 mb20 section_order"
      >
        {{orderByData.columnName}} : {{orderByData.desc === true ? $t('orderBy.descending'): $t('orderBy.ascending')}}
      </h6>
      <ReHabListSideMenu
          :check="check"
          :device="device"
          :selectedCategoryStatus="selectedCategoryStatus"
          @selectedCategory="selectedCategory"
          @selectedName="selectedName"
          @filterByDateRange="filterByDateRange"
          @onDeviceChange="handleDeviceChange"
      />
      <ReHabList
          :device="device"
          :selectedCategoryStatus="selectedCategoryStatus"
          :itemRowsProps="showRehabilitationList"
          @getAllMyPatientExerciseHistoryByLimit="getAllMyPatientExerciseHistoryByLimit"
          @orderBy="orderBy"
      />
      <DetailsAndRecordModal/>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import ReHabListSideMenu from './sideMenu/index'
import ReHabList from './list/index'
import DetailsAndRecordModal from '@/components/modal/detailsAndRecord'
import _API from "../../../../api";
import * as ENUM from "@/enum/lib";
import {
  _STATUS_KEY_RANGE,
  _MODE_KEY_RANGE,
  _PART_KEY_RANGE,
  _DIRECTION_KEY_RANGE,
  _ELBOW_METHOD_KEY_RANGE,
  _WRIST_METHOD_KEY_RANGE,
  _KNEE_ANKLE_METHOD_KEY_RANGE,
} from '@/components/Table/static'

export default {
  components: {
    ReHabList,
    ReHabListSideMenu,
    DetailsAndRecordModal,
  },
  data() {
    const check = this.getCheckTimeZone();

    const defaultData = {
      selectedCategoryStatus: check ? 6 : null,
      orderByData: {
        desc: true,
        columnKey: check ? 0 : 1,
        columnName: check ? this.$t('rehabilitation.duration') : this.$t('rehabilitation.due_date'),
      },
    }

    return {
      check: check,
      selectedCategoryStatus: defaultData.selectedCategoryStatus,
      // exerciseList: [],             // 원본 데이터
      refinedExerciseList: [],      // status 가 계산된 데이터
      pageInfo: {
        size: 20,
        currentPage: 0,
        isListOver: false,
      },
      values: {
        start: null, //new Date(new Date().setMonth(new Date().getMonth() - 1)),
        end: null, //new Date()
      },
      searchKeyword: undefined,
      tz: this.moment.tz.guess(true),
      orderByData: defaultData.orderByData,
      loading: false,
      device: 1,
    }
  },
  methods: {
    ...mapActions(['inspectSelectPatient']),
    ...mapGetters([
      'getCheckTimeZone',
    ]),
    selectedCategory(status) {
      if (this.loading === false) {
        this.selectedCategoryStatus = status;
      }
    },
    selectedName(key) {
      if (this.loading === false) {
        this.searchKeyword = key;
        // this.exerciseList = [];
        this.refinedExerciseList = [];
        this.pageInfo = {
          size: 20,
          currentPage: 0,
          isListOver: false,
        };
      }
    },
    showModal(_e, selectedExercise) {
      this.$modal.show('details-and-record-modal', selectedExercise);
    },
    getAllMyPatientExerciseHistoryByLimit(currentPage = null, done = () => {/*This is intentional*/
    }) {
      if (this.pageInfo.isListOver === false) {
        if (currentPage !== null)
          this.pageInfo.currentPage = currentPage;

        this.loading = true;

        if (this.selectedCategoryStatus !== 6) {
          const seqMedicalRelation = this.searchKeyword?.seqMedicalRelation;
          const seqManager = localStorage.getItem('seqManager');
          const data = {
            seqMedicalRelation,
            seqManager,
            startIndex: this.pageInfo.currentPage,
            size: this.pageInfo.size
          };

          const getAllMyPatientExerciseHistoryByLimit = this.searchKeyword?.seqMedicalRelation === undefined ?
              _API.EXERCISE_LIST.getAllMyPatientExerciseHistoryByLimit(data.seqManager, data.startIndex, data.size, this.orderByData, this.device) :
              _API.EXERCISE_LIST.getAllExerciseHistoryBySeqMedicalRelationByLimit(data, this.orderByData);

          getAllMyPatientExerciseHistoryByLimit
              .then(res => {
                this.pageInfo.isListOver = res.data.isListOver;
                this.pageInfo.currentPage += 1;

                if (res.data.isSuccess && res.data.exerciseList.length > 0) {
                  // for (let i = 0; res.data.exerciseList.length > i; i++)
                  //   this.exerciseList.push({
                  //     ...res.data.exerciseList[i],
                  //     patientInfoName: res.data.exerciseList[i]?.patientInfoName !== undefined ? res.data.exerciseList[i]?.patientInfoName : this.searchKeyword?.title
                  //   });
                  let tempData = [];
                  for (let exerciseValue of res.data.exerciseList) {
                    this.device === exerciseValue.seqDeviceType &&
                    tempData.push({
                      ...exerciseValue,
                      patientInfoName: exerciseValue?.patientInfoName !== undefined ? exerciseValue?.patientInfoName : this.searchKeyword?.title
                    });
                  }

                  Array.prototype.deepCopy(tempData.map((resData) => {
                    return {
                      ...resData,
                      patientInfoName: resData?.patientInfoName !== undefined ? resData?.patientInfoName : this.searchKeyword?.title
                    }
                  })).then(copiedExerciseList => {
                    this.refineExerciseList(copiedExerciseList);
                    done(true);
                  }).catch(e => {
                    done(false, 2, `[getAllMyPatientExerciseHistoryByLimit] ${e}`);
                  })
                } else if (res.data.exerciseList.length === 0) {
                  // 더이상 불러올 데이터가 없다
                  done(false, 1);
                } else {
                  //우리가 예측하지 못한 오류인 경우
                  done(false, 2, `[getAllMyPatientExerciseHistoryByLimit] unresolved error`);
                }
              })
              .finally(() => {
                this.loading = false;
              })
        } else {
          _API.EXERCISE_LIST.getAllBySearchWordAndSeqMedicalRelation(this.pageInfo.currentPage, this.pageInfo.size, this.searchKeyword?.seqMedicalRelation, this.orderByData, this.device)
              .then(res => {
                this.pageInfo.isListOver = res.data.isListOver;
                this.pageInfo.currentPage += 1;

                if (res.data.isSuccess && res.data.exerciseList.length > 0) {
                  let tempData = [];
                  for (let i = 0; res.data.exerciseList.length > i; i++) {
                    // this.exerciseList.push({
                    //   ...res.data.exerciseList[i],
                    //   exerciseEndDatetime: res.data.exerciseList[i].usageStartDatetime,
                    // });
                    let tempDate;
                    if (res.data.exerciseList[i].usageStartDatetime !== null)
                      tempDate = res.data.exerciseList[i].usageStartDatetime;
                    else
                      tempDate = res.data.exerciseList[i].createDatetime;

                    tempData.push({
                      ...res.data.exerciseList[i],
                      exerciseEndDatetime: tempDate,
                    });
                  }

                  Array.prototype.deepCopy(tempData)
                      .then(copiedExerciseList => {
                        this.refineExerciseList(copiedExerciseList);
                        done(true);
                      })
                      .catch(e => {
                        done(false, 2, `[getAllMyPatientExerciseHistoryByLimit] ${e}`);
                      })
                } else if (res.data.exerciseList.length === 0) {
                  // 더이상 불러올 데이터가 없다
                  done(false, 1);
                } else {
                  //우리가 예측하지 못한 오류인 경우
                  done(false, 2, `[getAllMyPatientExerciseHistoryByLimit] unresolved error`);
                }
              })
              .finally(() => {
                this.loading = false;
              })
        }
      } else {
        done(false, 1);
      }
    },
    filterByDateRange(item) {
      this.values.start = item.values ? item.values.start : null;
      this.values.end = item.values ? item.values.end : null;
    },
    refineExerciseList(copiedExerciseList) {
      // DB 에서 가져온 exerciseStatus 는 0,1,2 총 세개의 값이다.
      // 1 = 의사가 버튼을 눌러 중지시킨 경우
      // 2 = 의사가 버튼을 눌러 수행완료를 시킨 경우
      // 0 = 그 이외의 모든 경우
      // 이 메서드는 exerciseStatus 와 날짜, recordList(수행여부)를 기준으로 다시 status 값을 0,1,2,3,4,5로 총 6개로 재정의한다. 다음과 같다.
      //  0 = waiting / 1 = terminated / 2 = accomplished(수동) / 3 = accomplished(자동)/ 4 = on Progress / 5 = canceled
      for (let i = 0; copiedExerciseList.length > i; i++) {
        if (copiedExerciseList[i].exerciseStatus === 0) {
          // 마감일이 남아 있는 경우
          if (this.moment(copiedExerciseList[i].exerciseEndDatetime).diff(this.moment(), 'days') >= 0) {
            if (copiedExerciseList[i].exerciseCourseLength >= copiedExerciseList[i].exerciseSet) {
              // 운동을 부여받은 세트 이상으로 수행한 경우
              copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.ACCOMPLISHED_AUTO;
            } else if (copiedExerciseList[i].exerciseCourseLength >= 1) {
              // 운동을 1개 이상 수행한 경우
              copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.ON_PROGRESS;
            }
            continue
          }
          // 마감일이 남아 있지 않은 경우
          if (copiedExerciseList[i].exerciseCourseLength >= 1) {
            // 운동을 1개 이상 수행한 경우
            copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.ACCOMPLISHED_AUTO;
          } else {
            // 운동을 수행하지 않은 경우
            copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.CANCELED;
          }
        }
      }

      this.refinedExerciseList = [...this.refinedExerciseList, ...copiedExerciseList];
    },
    orderBy(event, item) {
      if (this.loading === false) {
        // this.exerciseList = [];
        this.refinedExerciseList = [];
        this.pageInfo = {
          size: 20,
          currentPage: 0,
          isListOver: false,
        };
        this.orderByData = {
          desc: this.orderByData.columnKey === item.values ? !this.orderByData.desc : this.orderByData.desc,
          columnKey: item.values,
          columnName: item.keyTitle,
        };
      }
    },
    handleDeviceChange(device) {
      if (this.loading === false) {
        if (this.device !== device) {
          this.device = device;
          this.handleClear();
        }
      }
    },
    handleClear(newValue = this.selectedCategoryStatus) {
      // this.exerciseList = [];
      this.refinedExerciseList = [];
      this.pageInfo = {
        size: 20,
        currentPage: 0,
        isListOver: false,
      };

      this.orderByData = {
        desc: true,
        columnKey: newValue === 6 ? 0 : 1,
        columnName: newValue === 6 ? this.$t('rehabilitation.duration') : this.$t('rehabilitation.due_date'),
      }
    },
  },
  watch: {
    selectedCategoryStatus: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.handleClear(newValue);
        }
      }
    }
  },
  computed: {
    //   filterItemRows: function () {
    //     let filteredItemRows = [];
    //
    //     // 선택한 카테고리가 있다면
    //     if (this.selectedCategoryStatus !== 6) {
    //       filteredItemRows = this.refinedExerciseList.filter((item) => {
    //         return this.selectedCategoryStatus === item.exerciseStatus || this.selectedCategoryStatus === null
    //       });
    //     } else {
    //       filteredItemRows = JSON.parse(JSON.stringify(this.refinedExerciseList));
    //     }
    //
    //     // 날짜를 선택했다면
    //     // if (this.values.start) {
    //     //   filteredItemRows = filteredItemRows.filter((item) => {
    //     //     const dueDate = this.moment(this.moment.tz(item.exerciseEndDatetime, this.tz).toDate());
    //     //     const start = this.moment.tz(this.values.start, this.tz);
    //     //     const end = this.moment.tz(this.values.end, this.tz);
    //     //     return dueDate.isBetween(start, end, 'days', '[]')
    //     //   })
    //     // }
    //     // 검색어가 있다면
    //     // if (this.searchKeyword.value) {
    //     //   filteredItemRows = filteredItemRows.filter((item) => {
    //     //     const isKeywordInUserName = item.patientInfoName.toLowerCase().indexOf((this.searchKeyword.value).toLowerCase());
    //     //     return isKeywordInUserName > -1
    //     //   })
    //     // }
    //
    //     return filteredItemRows;
    //   },
    showRehabilitationList: function () {
      let filteredItemRows = JSON.parse(JSON.stringify(this.refinedExerciseList));
      const itemRows = [];

      for (let filteredItem of filteredItemRows) {
        const items = [];

        if (this.selectedCategoryStatus !== 6) {
          const setDeviceItem = (exerciseGuide) => {
            if (this.device === 1) {
              const position = exerciseGuide.exerciseGuidePosition;
              let gripText = '';
              let deviceLoh = '';

              switch (position) {
                case ENUM.POSITION.ELBOW :
                  gripText = _ELBOW_METHOD_KEY_RANGE[exerciseGuide.exerciseGuideHandGripType - 1]?.trans;
                  break;
                case ENUM.POSITION.WRIST :
                  gripText = _WRIST_METHOD_KEY_RANGE[exerciseGuide.exerciseGuideHandGripType - 1]?.trans;
                  break;
                case ENUM.POSITION.KNEE :
                case ENUM.POSITION.ANKLE :
                default :
                  deviceLoh = _KNEE_ANKLE_METHOD_KEY_RANGE[exerciseGuide.exerciseGuideDeviceLoh]?.trans;
                  break;
              }

              items.push({
                index: 5,
                keyTitle: '',
                keyType: 'Default',
                class: ['pointer'],
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: this.$t(gripText),
              });
              items.push({
                index: 6,
                keyTitle: '',
                keyType: 'Default',
                class: ['pointer'],
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: this.$t(deviceLoh),
              });
            } else {
              // items.push({
              //   index: 5,
              //   keyTitle: '',
              //   keyType: 'Default',
              //   class: ['pointer'],
              //   parentClass: [],
              //   componentOptions: {},
              //   keyRange: [],
              //   values: exerciseGuide?.exerciseGuideMuscleStiffSensitive,
              // });
            }
          }

          if ((filteredItem.exerciseSet - filteredItem.exerciseCourseLength) <= 0)
            filteredItem.exerciseStatus = 3;

          items.meta = filteredItem;
          items.clickEvent = {
            func: this.showModal,
            params: [items.meta],
            key: filteredItem.seqExercise
          };
          items.push({
            index: 0,
            keyTitle: '',
            keyType: 'Default',
            class: ['pointer'],
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: filteredItem.patientInfoName,
          });
          items.push({
            index: 1,
            keyTitle: '',
            keyType: 'Default',
            class: ['pointer'],
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: filteredItem.exerciseGuide.exerciseGuideTitle,
          });
          items.push({
            index: 2,
            keyTitle: '',
            keyType: 'Default',
            class: [_STATUS_KEY_RANGE[filteredItem.exerciseStatus].class, 'pointer'],
            parentClass: [''],
            componentOptions: {},
            keyRange: '',
            values: this.$t(_STATUS_KEY_RANGE[filteredItem.exerciseStatus]?.trans)
          });
          items.push({
            index: 3,
            keyTitle: '',
            keyType: 'Default',
            class: ['pointer'],
            parentClass: [],
            componentOptions: {},
            keyRange: '',
            values: this.$t(_MODE_KEY_RANGE[filteredItem.exerciseGuide.exerciseGuideMode]?.trans)
          });
          items.push({
            index: 4,
            keyTitle: '',
            keyType: 'Default',
            class: ['pointer'],
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: this.$t(_DIRECTION_KEY_RANGE.data[filteredItem.exerciseGuide.exerciseGuideDirection]?.trans)
                + ' / ' + this.$t(_PART_KEY_RANGE.data[filteredItem.exerciseGuide.exerciseGuidePosition]?.trans)
          });
          setDeviceItem(filteredItem.exerciseGuide)
          items.push({
            index: 7,
            keyTitle: '',
            keyType: 'Default',
            class: ['pointer'],
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: filteredItem.exerciseCourseLength + '/' +
                filteredItem.exerciseSet + this.$t('rehabilitation.set')
          });
          items.push({
            index: 8,
            keyTitle: '',
            keyType: 'Default',
            class: ['pointer'],
            parentClass: [],
            componentOptions: {},
            keyRange: [],
            values: this.moment(filteredItem.exerciseEndDatetime).locale(this.$t('country')).format('ll'),
          });
        } else {
          items.clickEvent = {
            func: () => {
              this.inspectSelectPatient(filteredItem.seqPatient);
              this.$router.push(`/patientList/details/home?id=${filteredItem.seqPatient}`)
                  .then(() => {
                    setTimeout(() => {
                      const content = document.getElementById(`patientListDetails`);
                      const section = document.getElementById(`sectionHistory`);

                      content?.scrollTo(0, section?.offsetTop);
                    }, 1000);
                  })
            },
            params: [],
            key: filteredItem?.seqUserAssignedExerciseHistory || filteredItem?.seqUserAssignedReblessProExerciseHistory
          };

          if (this.device === 1) {
            items.push({
              index: 0,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: filteredItem.patientInfoName,
            });
            items.push({
              index: 1,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.moment(filteredItem.exerciseEndDatetime).locale(this.$t('country')).format('lll'),
            });
            items.push({
              index: 2,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.$t(_MODE_KEY_RANGE[filteredItem.iuppiterUsageMode]?.trans)
            });
            items.push({
              index: 3,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.$t(_DIRECTION_KEY_RANGE.data[filteredItem.exerciseGuideDirection]?.trans)
                  + ' / ' + this.$t(_PART_KEY_RANGE.data[filteredItem.exerciseGuidePosition]?.trans)
            });
            items.push({
              index: 4,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: `${filteredItem.iuppiterUsageMinAngle}° ~ ${filteredItem.iuppiterUsageMaxAngle}°`
            });
            items.push({
              index: 5,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: filteredItem.iuppiterUsageMode === 0 ? `${filteredItem.exerciseGuideExtension} / ${filteredItem.exerciseGuideFlexion}` : ``
            });
            items.push({
              index: 6,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: filteredItem.iuppiterUsageMode === 0 || filteredItem.iuppiterUsageMode === 1 ? `${filteredItem.iuppiterUsageCount} ${this.$t('rehabilitation.count')}` : '-',
            });
            items.push({
              index: 7,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: filteredItem.deviceUsageDuration === null ? `00:00:00` : filteredItem.deviceUsageDuration,
            });
            items.push({
              index: 8,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: `${filteredItem.iuppiterUsageMode !== 1 ? `-` : `${this.$t('rehabilitation.speed')} ${filteredItem.exerciseGuideSpeed}`}`,
            });
          } else {
            const mode = [
              ..._MODE_KEY_RANGE,
              {
                no: 4,
                title: 'record',
                trans: 'exercise.mode.record'
              }
            ];
            const part = {
              data: [
                ..._PART_KEY_RANGE.data,
                {
                  no: 5,
                  title: 'lowerExtremity',
                  trans: 'exercise.position.lowerExtremity',
                  value: [
                    {
                      rom: undefined,
                      wrong_min_range: undefined,
                      wrong_max_range: undefined,
                      minAngle: 0,
                      minRom: 0,
                      maxRom: 0,
                    },
                  ]
                },
              ],
              keyRange: [
                ..._PART_KEY_RANGE.keyRange,
                {
                  no: 5,
                  title: 'lowerExtremity',
                  trans: 'exercise.position.lowerExtremity',
                  value: [
                    {
                      rom: undefined,
                      wrong_min_range: undefined,
                      wrong_max_range: undefined,
                      minAngle: 0,
                      minRom: 0,
                      maxRom: 0,
                    },
                  ]
                },
              ],
            };

            items.push({
              index: 0,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: filteredItem.patientInfoName,
            });
            items.push({
              index: 1,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.moment(filteredItem.usageStartDatetime).locale(this.$t('country')).format('lll') // filteredItem.exerciseGuideTime,
            });
            items.push({
              index: 2,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.$t(mode[filteredItem.iuppiterUsageMode]?.trans)
            });
            items.push({
              index: 3,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: this.$t(_DIRECTION_KEY_RANGE.data[filteredItem.exerciseGuideDirection]?.trans)
                  + ' / ' + this.$t(part.data[filteredItem.exerciseGuidePosition]?.trans)
            });
            items.push({
              index: 4,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: `${filteredItem.exerciseGuideExtension} / ${filteredItem.exerciseGuideFlexion}`
            });
            items.push({
              index: 5,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: `${filteredItem.exerciseGuideAnkleMinRom} / ${filteredItem.exerciseGuideAnkleMaxRom}`
            });
            items.push({
              index: 6,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: `${filteredItem.exerciseGuideKneeMinRom} / ${filteredItem.exerciseGuideKneeMaxRom}`
            });
            items.push({
              index: 7,
              keyTitle: '',
              keyType: 'Default',
              class: ['pointer'],
              parentClass: [],
              componentOptions: {},
              keyRange: [],
              values: `${this.$t('rehabilitation.speed')} ${filteredItem.exerciseGuideSpeed}`,
            });
          }
        }

        itemRows.push(items);
      }

      if (this.selectedCategoryStatus !== 6) {
        return itemRows.filter((item) => {
          return this.$t(_STATUS_KEY_RANGE[this.selectedCategoryStatus]?.trans) === item[2].values || this.selectedCategoryStatus === null
        });
      } else {
        return itemRows;
      }
    }
  }
}
</script>
<style lang="scss">
.RehabList {
  overflow: auto;
}

.rehab_list_section {
  .section_wrap {
    display: grid;
    grid-template-columns: 1fr 5fr;
    grid-template-rows: 50px 1fr;
    overflow: hidden;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 1rem;
    flex: 1 1 1rem;
    height: calc(var(--app-height) - 180px);

    .section_title {
      grid-row: 1/2;
      grid-column: 1/3;
    }

    .section_order {
      position: absolute;
      top: 20px;
      right: 0;
      font-size: 14px;
      color: var(--grey70);
    }
  }

  .md_content_1 {
    .section_wrap {
      height: 600px;
    }
  }

  .md_content_2 {
    .section_wrap {
      height: 600px;
    }
  }

  .cure_list {
    overflow-y: auto;
    height: calc(var(--app-height) - 260px) !important;

    .table-container {

      .table-header {
        position: sticky;
        top: 0;
        background: #f7f7f7;

        .item-value:nth-child(1) {
          flex-grow: 4 !important;
        }

        .item-value:nth-child(2) {
          flex-grow: 7 !important;
        }
      }

      .table-body {
        .item-value:nth-child(1) {
          flex-grow: 4 !important;
        }

        .item-value:nth-child(2) {
          flex-grow: 7 !important;
        }
      }
    }
  }

  .rehabSelect {
    .vs__dropdown-menu {
      max-height: 200px;
      overflow: scroll;
    }

    &.open {
      .vs__dropdown-menu {
        max-height: 120px;
      }
    }

    .option {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>